import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0D1117',
      color: '#E2E8F0',
      fontFamily: 'Inter, sans-serif',
      padding: '40px 24px',
    }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 32, marginBottom: 8 }}>
          Privacy Policy
        </h1>
        <p style={{ color: '#9CA3AF', fontSize: 14, marginBottom: 32 }}>
          Last updated: June 12, 2026
        </p>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            1. Introduction
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            L.O.J Enterprise Ltd ("we", "us", or "our") operates the Multi Author application. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our application and services.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            2. Information We Collect
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1', marginBottom: 12 }}>
            <strong>Account Information:</strong> When you create an account, we collect your username, email address, and password (stored securely).
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1', marginBottom: 12 }}>
            <strong>Content Data:</strong> We store the content you create through our AI writing team, including briefs, drafts, and published articles.
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1', marginBottom: 12 }}>
            <strong>Payment Information:</strong> Payments are processed securely through Stripe. We do not store your credit card details on our servers.
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            <strong>Usage Data:</strong> We collect anonymised usage analytics to improve our service, including feature usage patterns and performance metrics.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            3. How We Use Your Information
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            We use your information to: provide and maintain our service, process transactions, send transactional emails, improve our AI models and content quality, and comply with legal obligations.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            4. Data Sharing
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            We do not sell your personal information. We may share data with: Stripe (payment processing), OpenAI (AI content generation, only when you provide your own API key), and analytics providers (anonymised data only).
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            5. Data Security
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            We implement industry-standard security measures including encryption in transit (TLS) and at rest, secure authentication, and regular security audits. However, no method of transmission over the Internet is 100% secure.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            6. Your Rights
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            You have the right to: access your personal data, correct inaccurate data, delete your account and data, export your data, and opt out of non-essential data collection. To exercise these rights, contact us at support@lojenterprise.com.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            7. Children's Privacy
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take steps to delete it.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            8. Changes to This Policy
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 20, color: '#F97316', marginBottom: 12 }}>
            9. Contact Us
          </h2>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#CBD5E1' }}>
            If you have questions about this Privacy Policy, please contact us at support@lojenterprise.com
          </p>
        </section>
      </div>
    </div>
  );
}
